/* ANGULAR */
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

/* PIPE */
import { NumPipe } from './pipes/num.pipe';
import { RangePipe } from './pipes/range.pipe';
import { NumberFormatPipe } from './pipes/number-format.pipe';
import { TypePipe } from './pipes/type.pipe';

/* SERVICE */
import { AuthService } from '../auth.service';
import { UtilsService } from "./services/utils.service";

/* SERVICE */


/* GUARD */
import { AuthGuard } from "../auth.guard";


@NgModule({
  declarations: [
    NumPipe,
    RangePipe,
    NumberFormatPipe,
    TypePipe
  ],
  imports: [
    BrowserModule,
  ],
  providers: [
    AuthGuard,
    NumPipe,
    RangePipe,
    NumberFormatPipe,
    TypePipe,
    AuthService,
    UtilsService
  ],
  exports: [
    NumPipe,
    RangePipe,
    NumberFormatPipe,
    TypePipe
  ]
})

export class SharedModule { }
export { NumPipe, RangePipe, NumberFormatPipe, TypePipe, UtilsService }



// WEBPACK FOOTER //
// ./src/app/shared/shared.module.ts